import { FunctionComponent, PropsWithChildren } from 'react';

const SearchSuppliersContainer: FunctionComponent<PropsWithChildren> = ({ children }) => (
  <div className="mx-auto w-full max-w-[1078px] px-6" data-name="search-suppliers-container">
    {children}
  </div>
);

export default SearchSuppliersContainer;
